import { Button, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'next-i18next';

const ContinueButton = ({ onClick, disabled = false }: { text?: string; onClick?: () => void; disabled?: boolean }) => {
	const theme = useTheme();
	const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
	const { t } = useTranslation('continueButton');

	return (
		<Button
			type="submit"
			variant="primaryDefault"
			size="M"
			fullWidth={isSmallScreen}
			onClick={onClick}
			disabled={disabled}
		>
			{t('continue')}
		</Button>
	);
};

export default ContinueButton;
